import { SlateLabelEnum, type Contest as APIContest } from '@betterpool/api-types/contests-service';

import pickPropertiesFromObject from '~/domains/common/utils/pickPropertiesFromObject';

import type { Contest } from '../interfaces/contest.interface';

function parseContest(response: APIContest): Contest {
  const sourceEntries = response.entries as APIContest['entries'] & { userAnyStake?: number };
  const { userAnyStake, ...entries } = sourceEntries;
  return {
    ...pickPropertiesFromObject(response, [
      'id',
      'contest_template_id',
      'name',
      'commissioner',
      'entries',
      'tags',
      'prize_pool',
      'status',
      'unlisted',
      'beginnersOnly',
      'paid_out_at',
      'is_after_first_late_swap_deadline',
      'created_by_admin',
      'resizing_mode',
      'league',
      'banner_url',
      'thumbnail_url',
      'is_allowed_in_location',
      'entry_fee',
      'entry_fee_in_dollars',
      'custom_logo',
      'is_entry_deadline_pending',
      // @ts-expect-error: this will be added to api-types in the future
      'manage_entrants',
    ]),
    entries: {
      ...entries,
      ...(userAnyStake === undefined ? {} : { user_any_stake: userAnyStake }),
    },
    start_date: new Date(response.start_date),
    end_date: new Date(response.end_date),
    settings: {
      ...response.settings,
      slateLabel: response.settings?.slateLabel ?? SlateLabelEnum.SLATE,
    },
  };
}

export default parseContest;
